import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { MdClose, MdOutlineAutoDelete } from 'react-icons/md';
import { FaChevronDown, FaRegEye, FaRegFileArchive } from 'react-icons/fa';
import { ColorRing, InfinitySpin } from 'react-loader-spinner';
import { api_url } from '../../../config';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import EditUser from './EditUser';
import { CiExport, CiMenuKebab } from "react-icons/ci";
import { GrEdit } from 'react-icons/gr';
import { IoArchiveOutline } from 'react-icons/io5';
import UserDetails from './UserDetails';
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { VscLayersActive } from 'react-icons/vsc';
import { FcSearch } from 'react-icons/fc';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { hasPermission } from '../../../Redux/permissionSlice';
import { selectRoles } from '../../../Redux/AuthSlice';
import DeleteUserModal from './DeleteUserModal';
import ArchiveUserModal from './ArchiveUserModal';
import AddUserForm from './AddUserForm';
import api from '../../../utils/api';
import { getPageNumbers } from '../../../utils/getPageNumbers';
import exportFromJSON from 'export-from-json';
import Table from '../../../components/dataUi/Table';
import { FaGreaterThan } from "react-icons/fa";

const UserInfo = () => {
    const [editMode, setEditMode] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
    const [showArchiveUserModal, setShowArchiveUserModal] = useState(false);
    const [showReactivateUserModal, setShowReactivateUserModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [loading, setLoading] = useState(true)
    const [branchDetail, setBranchDetail] = useState(null)
    const { token, id, branch_id } = useSelector((state) => state.auth)
    const modalRef = useRef();
    const popUpRef = useRef();
    const status = ['', 'All', 'Active', 'Inactive', 'Archived']
    const [users, setUsers] = useState([]);
    const [user_amount, setUser_amount] = useState();
    const [userToEdit, setUserToEdit] = useState([]);
    const [userToDelete, setUserToDelete] = useState([]);
    const [userToArchive, setUserToArchive] = useState([]);
    const [selectedDropdown, setSelectedDropdown] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userView, setUserView] = useState(false)
    const [selectedUserDetails, setSelectedUserDetails] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [userQuery, setUserQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState();
    const [limit, setLimit] = useState(50)
    const [newLimit, setNewLimit] = useState(50);
    const [filter, setFilter] = useState('')
    const [filter_by, setFilter_by] = useState('')
    const [showbtn, setShowbtn] = useState(false)
    const [search, setSearch] = useState('')
    const [hasSearched, setHasSearched] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false)
    const [sortby, setSortby] = useState('-created_at')
    const [showDateSort, setShowDateSort] = useState(false)
    const [hadUsers, setHadUsers] = useState(false);
    const [metadata, setMetadata] = useState('')




    const selectedRoles = useSelector(selectRoles);
    const roles = Array.isArray(selectedRoles) ? selectedRoles : selectedRoles.split(',').map(role => role.trim());

    const handleLimitChange = (e) => {
        setNewLimit(parseInt(e.target.value));
    };

    const applyNewLimit = () => {
        setLimit(newLimit);
    };

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleStatusChange = (status) => {
        if (status === selectedStatus) {
            setLoading(false);
            return;
        }
        setHasSearched(false)
        setLoading(true);

        let newFilter;
        let newFilter_by;
        if (status === 'Active') {
            newFilter = 'active';
            newFilter_by = 'status';
        } else if (status === 'Inactive') {
            newFilter = 'inactive';
            newFilter_by = 'status';

        } else if (status === 'Archived') {
            newFilter = 'archived';
            newFilter_by = 'status';

        } else if (status === 'All') {
            newFilter = '';
            newFilter_by = '';

        } else {
            newFilter = 'active,inactive,archived';
            newFilter_by = 'status';

        }
        setFilter_by(newFilter_by)
        setFilter(newFilter);
        setShowbtn(true);

        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };

    const handleEdit = () => {
        setShowEditModal(!showEditModal); // Enable edit mode
    };

    const handleDeleteUser = (event, userId) => {
        if (event) {
            event.preventDefault(); // Prevent default behavior
            event.stopPropagation();
        }
        const userToDelete = users.find(user => user.id === userId);
        if (userToDelete) {
            setShowDeleteUserModal(true);
            setUserToDelete(userToDelete); // Assuming you have state to store user to edit
        }
    };

    const togglePopUp = (event, index, user) => {
        event.stopPropagation();
        event.preventDefault();
        if (index === selectedDropdown) {
            setSelectedDropdown(null);
            setSelectedUser(null); // Deselect branch if clicking on the same dropdown
        } else {
            setSelectedDropdown(index);
            setSelectedUser(user);
        }
    };


    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowEditModal(false)
            }
            if (popUpRef.current && !popUpRef.current.contains(event.target)) {
                setSelectedDropdown(null);
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        // Function to handle click outside of modal
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
                setShowEditModal(false)
                setShowEditUserModal(false)
                setShowDeleteUserModal(false)
                setShowArchiveUserModal(false)
            }
        };

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const handleEditUser = (event, userId) => {
        if (event) {
            event.preventDefault(); // Prevent default behavior
            event.stopPropagation();
        }
        const userToEdit = users.find(user => user.id === userId);
        if (userToEdit) {
            setShowEditUserModal(true);
            setUserToEdit(userToEdit); // Assuming you have state to store user to edit
        }
    };
    const handleArchiveUser = (event, userId) => {
        if (event) {
            event.preventDefault(); // Prevent default behavior
            event.stopPropagation();
        }
        const userToArchive = users.find(user => user.id === userId);
        if (userToArchive) {
            setShowArchiveUserModal(true);
            setUserToArchive(userToArchive); // Assuming you have state to store user to edit
        }
    };

    //using this to get user details and push to the userdetails component
    const handleUserView = (selectedUser) => {
        setSelectedUserDetails(selectedUser);
        setUserView(true);
    }


    const handleNextPage = () => {
        if (currentPage < lastPage) {
            setCurrentPage(currentPage + 1);

        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const fetchUsers = async (page, limit, searchQuery) => {
        const params = {
            page: page || 1,
            limit: limit || 50,
            sort: sortby,
            [`filter[${filter_by}]`]: `${filter}`,
            search: `${searchQuery || ''}`

        };

        try {
            const response = await api.get(api_url + `/api/v1/retailer/user/${id}/branch/${branch_id}/user-profile`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                params
            });
            const data = response.data.data;
            const meta = response.data.meta

            setUsers(data)
            setMetadata(meta)
            setUser_amount(response.data.meta.total);
            setLastPage(response.data.meta.last_page)
            if (data.length > 0) {
                setHadUsers(true);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false)

        }
    };

    useEffect(() => {
        fetchUsers(currentPage, limit);

    }, [showEditModal, currentPage, limit, filter, filter_by, sortby])


    const handleSearchClick = async (searchQuery) => {


        setShowbtn(false);
        setHasSearched(true);
        setSearchLoading(!searchLoading)

        try {
            await fetchUsers(1, 50, searchQuery);;
            setHasSearched(true);
        } catch (error) {
            console.log(error);
        } finally {
            setSearchLoading(false)
        }


    };

    // Add a function for the Table component's search
    const handleSearch = (value) => {
        setSearch(value);
        if (!value.trim() || !users) {
            return;
        }
        handleSearchClick(value);
    };

    const handleSortDateAsc = () => {
        setSortby('created_at')
        setShowDateSort(!showDateSort)
    }

    const handleSortDateDsc = () => {
        setSortby('-created_at')
        setShowDateSort(!showDateSort)

    }

    const showEmptydivHelper = () => {
        setHasSearched(false)
        setShowbtn(false)
        setHadUsers(true)
    }

    const toggleUserForm = () => {
        setShowModal(!showModal)
    };

    const exportFunc = () => {
        const data = users?.map(u => ({
            id: u.id,
            Name: u.first_name + " " + u.last_name,
            Position: u.position,
            Email: u.email,
            Username: u.username,
            Contact: u.phone,
            Date_created: new Date(u?.created_at).toLocaleDateString(),
            Created_by: u.created_by,
            Status: u.status


        }))
        const fileName = 'Users'
        const exportType = exportFromJSON.types.csv

        exportFromJSON({ data, fileName, fields: ["id", "Name", "Position", "Email", "Username", "Date_created", "Created_by", "Status"], exportType })

    }

    // Format user data for Table component
    const formatUsersForTable = () => {
        return users.map((user, index) => ({
            number: index + 1,
            name: `${user.first_name} ${user.last_name}`,
            position: user.position,
            email: user.email,
            username: user.username,
            phone: user.phone,
            created_at: new Date(user.created_at).toLocaleDateString(),
            created_by: user.created_by,
            status: user.status,
            _originalData: user
        }));
    };

    // Define table headers
    const tableHeaders = [
        { key: 'number', label: 'No.', sortable: false },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'position', label: 'Position', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'username', label: 'Username', sortable: true },
        { key: 'phone', label: 'Contact', sortable: true },
        { key: 'created_at', label: 'Date created', sortable: true },
        { key: 'created_by', label: 'Created by', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
    ];

    // Define actions for table rows
    const tableActions = [
        {
            label: 'View',
            variant: 'primary',
            icon: <FaRegEye className="text-xs" />,
            onClick: (row) => handleUserView(row._originalData)
        },
        {
            label: 'Edit',
            variant: 'secondary',
            icon: <GrEdit className="text-xs" />,
            onClick: (row) => {
                if (row._originalData.status === 'inactive' || row._originalData.status === 'active') {
                    const userToEdit = users.find(user => user.id === row.id);
                    if (userToEdit) {
                        setShowEditUserModal(true);
                        setUserToEdit(userToEdit);
                    }
                }
            },
            showIf: (row) => (row._originalData.status === 'inactive' || row._originalData.status === 'active') &&
                hasPermission(roles, ['userWriter', 'userAdmin'])
        }
    ];

    // Define status configuration for styling
    const statusConfig = {
        'active': {
            label: 'Active',
            className: 'bg-green-200 text-green-800 border border-green-400'
        },
        'inactive': {
            label: 'Inactive',
            className: 'bg-red-200 text-red-800 border border-red-400'
        },
        'archived': {
            label: 'Archived',
            className: 'bg-gray-400 text-white border border-gray-900'
        }
    };

    return (

        <div className='absolute w-full h-full font-lufga'>
            {
                !userView ? (
                    <div>
                        {loading && ( // Display loader while loading
                            <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full bg-gradient-to-br from-opacity-40 to-opacity-60 backdrop-blur-sm">
                                <InfinitySpin color="#059212" loading={loading} size={40} />
                            </div>
                        )}
                        {!loading && (<div className=''>
                            {users.length > 0 ? (
                                <div className="mx-6 font-lufga">
                                    <Table
                                        headers={tableHeaders}
                                        rows={formatUsersForTable()}
                                        actions={tableActions}
                                        emptyMessage={search ? `No results found for "${search}"` : "No users available"}
                                        headerBgColor="bg-green-200"
                                        onRowClick={(row) => handleUserView(row._originalData)}
                                        title="Users"
                                        itemsPerPage={limit}
                                        searchPlaceholder="Search users..."
                                        onSearch={handleSearch}
                                        onAdd={hasPermission(roles, ['userWriter', 'userAdmin']) ? toggleUserForm : undefined}
                                        addButtonText="Add User"
                                        addButtonClassName="bg-green-500 hover:bg-green-600 text-white"
                                        exportButtonText="Export"
                                        onExport={exportFunc}
                                        statusConfig={statusConfig}
                                        className="text-xs"
                                        filterOptions={[
                                            { label: 'Active', value: 'active' },
                                            { label: 'Inactive', value: 'inactive' },
                                            { label: 'Archived', value: 'archived' }
                                        ]}
                                    />
                                </div>
                            ) : (
                                <div>
                                    {showbtn ? (
                                        <div className="flex flex-col items-center justify-center font-lufga h-[80vh] sm:h-[65vh]">
                                            <p className="text-xs text-center text-gray-500">{`No ${filter} users`}</p>
                                            <button
                                                onClick={() => {
                                                    handleStatusChange('All');
                                                    setHadUsers(false);

                                                }}
                                                className="px-4 py-2 mt-4 text-white bg-green-500 rounded-sm shadow-md hover:opacity-90">Go back</button>
                                        </div>
                                    ) : hasSearched ? (
                                        <div className="flex flex-col items-center justify-center font-lufga h-[80vh] sm:h-[65vh]">
                                            <p className="text-xs text-center text-gray-500">No users found</p>
                                            <button onClick={() => { handleSearchClick() }} className="px-4 py-2 mt-4 text-white bg-green-500 rounded-sm shadow-md hover:opacity-90">{searchLoading ? <ColorRing
                                                height="20"
                                                width="20"
                                                ariaLabel="color-ring-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="color-ring-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            /> : "Go back"}</button>
                                        </div>
                                    ) : hadUsers ? (
                                        <div className="flex flex-col items-center justify-center font-lufga h-[80vh] sm:h-[65vh]">
                                            <p className="text-xs text-center text-gray-500">Empty List</p>
                                            {hasPermission(roles, ['userWriter', 'userAdmin']) && (
                                                <button onClick={toggleUserForm} className="px-4 py-2 mt-4 text-white bg-green-500 rounded-sm shadow-md hover:opacity-90">Add Users</button>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center font-lufga h-[80vh] sm:h-[65vh]">
                                            <p className="text-xs text-center text-gray-500">Get Started</p>
                                            {hasPermission(roles, ['userWriter', 'userAdmin']) && (
                                                <button onClick={toggleUserForm} className="px-4 py-2 mt-4 text-white bg-green-500 rounded-sm shadow-md hover:opacity-90">Add Users</button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            {showEditUserModal && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                                    <div ref={modalRef} className="bg-white rounded-md max-h-[90vh] overflow-auto shadow-lg p-6">
                                        <MdClose size={24} onClick={() => setShowEditUserModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                        <EditUser toggle={() => setShowEditUserModal(false)} user={userToEdit} fetchUsers={fetchUsers} users={users} />
                                    </div>
                                </div>
                            )}
                            {showDeleteUserModal && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                                    <div ref={modalRef} className="p-6 bg-white rounded-md shadow-lg min-h-max">
                                        <MdClose size={24} onClick={() => setShowDeleteUserModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                        <DeleteUserModal toggle={() => setShowDeleteUserModal(false)} user={userToDelete} fetchUsers={fetchUsers} users={users} showEmptydivHelper={showEmptydivHelper} />
                                    </div>
                                </div>
                            )}
                            {showArchiveUserModal && (
                                <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                                    <div ref={modalRef} className="p-6 bg-white rounded-md shadow-lg min-h-max">
                                        <MdClose size={24} onClick={() => setShowArchiveUserModal(false)} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                        <ArchiveUserModal toggle={() => setShowArchiveUserModal(false)} user={userToArchive} fetchUsers={fetchUsers} users={users} />
                                    </div>
                                </div>
                            )}


                        </div>)}

                        {showModal && (
                            <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
                                <div ref={modalRef} className="bg-white rounded-md max-h-[90vh] overflow-auto shadow-lg p-6">
                                    <MdClose size={24} onClick={toggleUserForm} className='transition duration-150 ease-out cursor-pointer hover:scale-105 hover:text-red-800 ' />
                                    <AddUserForm toggle={toggleUserForm} fetchUsers={fetchUsers} />
                                </div>
                            </div>
                        )}



                    </div>

                ) : userView && (<div className=''>
                    {/* <div>
                        <p onClick={() => { setUserView(false) }} className='flex items-center gap-1 mb-4 cursor-pointer hover:text-neutral-400'><IoArrowBackCircleOutline size={28} />Go back</p>

                    </div> */}
                    <div className='mx-10 mt-4'>
                        <p className='text-xl font-semibold lg:text-3xl text-slate-600'>User Details</p>
                    </div>
                    <div className='flex items-center gap-2 mx-10 my-2'>
                        <p onClick={() => { setUserView(false) }} className='flex items-center gap-1 text-green-700 cursor-pointer'>Users</p>
                        <p className=''><FaGreaterThan size={10} /></p>
                        <p>User Details</p>
                    </div>
                    <div className='grid gap-8 rounded-sm shadow-md lg:grid-cols-[minmax(50px,250px)_repeat(5,1fr)] lg:gap-0'>
                        <div className='col-span-4 lg:col-span-1  relative flex flex-col gap-2 max-h-[60vh] sm:max-h-[90vh] overflow-auto bg-neutral-100'>
                            <div className='sticky top-0 p-2 z-1 bg-neutral-100 w-100'>
                                <p className='w-full text-sm font-semibold font-lufga '>User List</p>

                            </div>
                            {users.map((data) => (
                                <div key={data?.id} className={`cursor-pointer  mx-2 p-[1rem] py-2 bg-white hover:bg-green-200 ${selectedUserDetails && selectedUserDetails.id === data.id ? 'bg-neutral-200' : ''}`} onClick={() => handleUserView(data)}>
                                    <p className='text-sm font-semibold leading-5'>{`${data?.first_name} ${data?.last_name}`}</p>
                                    <p className='text-sm leading-5 text-green-600'>{data?.email} </p>
                                </div>
                            ))}
                            <div className="sticky bottom-0 left-0 right-0 p-2 bg-neutral-100">
                                <div className='flex items-center gap-1'>
                                    <button onClick={handlePrevPage} disabled={currentPage === 1} className={currentPage === 1 ? 'hidden' : 'text-xs text-green-600'}>Prev</button>
                                    <div className='flex items-center gap-1'>
                                        {Array.from({ length: lastPage }, (_, i) => (
                                            <button key={i + 1} onClick={() => handlePageClick(i + 1)} className={`text-xs ${currentPage === i + 1 ? 'font-bold' : ''}`}>{i + 1}</button>
                                        ))}
                                    </div>
                                    <button onClick={handleNextPage} disabled={currentPage === lastPage} className={currentPage === lastPage ? 'hidden' : 'text-xs text-green-600'}>Next</button>
                                </div>
                            </div>
                        </div>

                        <div className='col-span-4 lg:col-span-5 p-2 max-h-[60vh] lg:max-h-[80vh] overflow-auto mx-2'>
                            <p className='w-full text-sm font-bold font-lufga '>Details</p>
                            <UserDetails user={selectedUserDetails} roles={roles} users={users} />
                        </div>
                    </div>
                </div>)}
        </div>
    );
}

export default UserInfo;